import { useRequest } from "ahooks";
import { api } from "@redux/api";
import moment from "moment";
import { shallowEqual, useSelector } from "react-redux";
import { getFacilityContext } from "@/utils/route-context";
import { bindSummarySnapshot, summaryQueryKey } from "./summarySnapshot.mjs";

const useBoundUtilityRequest = (kind, type, period, endingMonth) => {
  const { companyId, facilityId } = useSelector(getFacilityContext, shallowEqual);
  const queryKey = summaryQueryKey(kind, type, companyId, facilityId, period, endingMonth);
  const request = useRequest(async () => {
    if (!["electricity", "gas"].includes(type)) throw new Error("Invalid utility type");
    let result;
    if (kind === "summary") {
      result = type === "electricity"
        ? await api.get_electricity_summary(period, endingMonth)
        : await api.get_gas_summary(period, endingMonth);
    } else {
      const start = moment(endingMonth).subtract(period - 1, "month").startOf("month").format("YYYY-MM-DD");
      const end = moment(endingMonth).endOf("month").format("YYYY-MM-DD");
      const query = `start_month=${start}&end_month=${end}&page=1&page_size=20000`;
      result = type === "electricity" ? await api.filterElectricity(query) : await api.filterGas(query);
    }
    if (result?.status !== 200) throw new Error("Failed to fetch utility data");
    return {
      queryKey,
      capturedAt: new Date().toISOString(),
      data: kind === "summary" ? result.data : result.data?.results ?? [],
    };
  }, {
    refreshDeps: [queryKey],
    cacheKey: `utility-snapshot:${queryKey}`,
  });
  return bindSummarySnapshot(request, queryKey);
};

export const useSummaryData = (type, period, endingMonth) =>
  useBoundUtilityRequest("summary", type, period, endingMonth);

export const useWeatherData = (type, period, endingMonth) =>
  useBoundUtilityRequest("weather", type, period, endingMonth);
